import { render, staticRenderFns } from "./insuadd.vue?vue&type=template&id=2a4af793&scoped=true&"
import script from "./insuadd.vue?vue&type=script&lang=js&"
export * from "./insuadd.vue?vue&type=script&lang=js&"
import style0 from "./insuadd.vue?vue&type=style&index=0&id=2a4af793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4af793",
  null
  
)

export default component.exports